import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const SevenYardDraw = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === '7yard');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default SevenYardDraw;
